var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVelocityCurrencyOutlineIcon = function SvgVelocityCurrencyOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VelocityCurrencyOutlineIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "VelocityCurrencyOutlineIcon_svg__b",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#VelocityCurrencyOutlineIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.603C6.492 1.603 1.603 6.491 1.603 12.5c0 6.008 4.889 10.896 10.897 10.896S23.397 18.508 23.397 12.5 18.508 1.603 12.5 1.603m0 22.324C6.2 23.927 1.073 18.8 1.073 12.5S6.199 1.073 12.5 1.073 23.927 6.199 23.927 12.5 18.801 23.927 12.5 23.927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.46 7.69-3.042 8.258L9.395 7.69H6.629l4.618 11.323h2.32L18.163 7.69zM19.483 14.161l-.02.023a.37.37 0 0 1-.236.089l.239-.84.143-.507-.142-.003-.712-.02-.44.303-.04.024c-.028.016-.059-.016-.042-.044l.238-.383v-.095l-.229-.387c-.016-.028.016-.06.043-.043l.039.025.434.307.71-.01.159-.001-.027-.098-.341-1.253c.195.016.254.115.254.115l.173.27.37.572.025.04.215.334.548.004c.421.002.51.191.51.191s-.093.188-.514.185l-.547-.004-.061.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.747 13.084v-.682l-12.711.359z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VelocityCurrencyOutlineIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgVelocityCurrencyOutlineIcon;